/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconChevronRight from '@telus-uds/palette-public-mobile/build/rn/icons/ChevronRight'
import PaletteIconPause from '@telus-uds/palette-public-mobile/build/rn/icons/Pause'
import PaletteIconPlaySolid from '@telus-uds/palette-public-mobile/build/rn/icons/PlaySolid'
import PaletteIconChevronLeft from '@telus-uds/palette-public-mobile/build/rn/icons/ChevronLeft'
const theme = {
  appearances: {
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: { showPanelTabs: false, showPreviousNextNavigation: false }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    iconBackgroundColor: '#fefefc',
    nextIcon: PaletteIconChevronRight,
    pauseIcon: PaletteIconPause,
    playIcon: PaletteIconPlaySolid,
    previousIcon: PaletteIconChevronLeft,
    showPanelNavigation: true,
    showPanelTabs: true,
    showPreviousNextNavigation: true,
    spaceBetweenSlideAndPanelNavigation: 32,
    spaceBetweenSlideAndPreviousNextNavigation: 24,
    stepTrackerCurrentBackgroundColor: null
  }
}
export default theme
